import * as firmwareErrorCodes from '../../../consts/iot/firmwareErrorCodes';

export default class FwuDownloadOrParseError extends Error {
    constructor(e) {
        super(e);
        this.message = e;
        this.code = firmwareErrorCodes.CHECK_ERROR_DOWNLOAD_OR_PARSE;
    }
}
